import { ThemeContext } from './Contexts';
import { useState } from 'react'; 
import WorkspaceThemeColors from './WorkspaceThemeColors';



export default function ThemeContextWrapper({
  children
}){

  

  let colors = WorkspaceThemeColors();

  const [ index, setIndex ] = 
    useState(
      colors.length - 1
    );

  return (
    <ThemeContext.Provider value={{index,style:colors[index],setIndex}}>

      {children}

      {false && <div style={{
        left:500,
        top:100
      }} class="fixed-overlay flex">

        {colors.map(c => {
          if(!c){ return null; }

          return (
            <div class="fair-margin" style={{

              width:40,
              height:40,
              ...c

            }}/>
          )
        })}
      </div>}


    </ThemeContext.Provider>
  )
}
